const RoutesPaths = {
  // RECEIPTS
  receipts: {
    all: "/receipts",
    _configure: "/configure/receipts",
    //
    configure_profile: "/configure/receipts/profile",
    configure_profile_hash: (hash) => `/configure/receipts/profile/${hash}`,
    //
    configure_business: "/configure/receipts/business",

    // Admin (support) view of a merchant's Configure, under Business settings.
    // The BA these render for comes from the `business_account_id` query param
    // (see BusinessSettings/index.js), so every navigation between these must
    // carry the current `search` along with the path.
    admin_configure_business: "/business_settings/receipts/configure",
    admin_configure_profile: "/business_settings/receipts/configure/profile",
    admin_configure_profile_hash: (hash) => `/business_settings/receipts/configure/profile/${hash}`
  }
}

export { RoutesPaths }
